/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantHealthEmailSuppressions
 */
export interface TenantHealthEmailSuppressions {
    /**
     * 
     * @type {number}
     * @memberof TenantHealthEmailSuppressions
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthEmailSuppressions
     */
    hard_bounce?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthEmailSuppressions
     */
    complaint?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthEmailSuppressions
     */
    soft_bounce?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthEmailSuppressions
     */
    manual?: number;
}

/**
 * Check if a given object implements the TenantHealthEmailSuppressions interface.
 */
export function instanceOfTenantHealthEmailSuppressions(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantHealthEmailSuppressionsFromJSON(json: any): TenantHealthEmailSuppressions {
    return TenantHealthEmailSuppressionsFromJSONTyped(json, false);
}

export function TenantHealthEmailSuppressionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantHealthEmailSuppressions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'hard_bounce': !exists(json, 'hard_bounce') ? undefined : json['hard_bounce'],
        'complaint': !exists(json, 'complaint') ? undefined : json['complaint'],
        'soft_bounce': !exists(json, 'soft_bounce') ? undefined : json['soft_bounce'],
        'manual': !exists(json, 'manual') ? undefined : json['manual'],
    };
}

export function TenantHealthEmailSuppressionsToJSON(value?: TenantHealthEmailSuppressions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'hard_bounce': value.hard_bounce,
        'complaint': value.complaint,
        'soft_bounce': value.soft_bounce,
        'manual': value.manual,
    };
}

